export * from "./prepareMagentoPostCodeConfig";
